module.exports = __webpack_public_path__ + "3fb6c90c62939679ee99e759c9bf0b87.svg";